export type WithReplacedAttribute<
  T extends {},
  K extends keyof T,
  NT extends T[K]
> = Omit<T, K> &
  {
    [P in K]: NT;
  };

export type WithNonNullAttribute<
  T extends {},
  K extends keyof T
> = WithReplacedAttribute<T, K, NonNullable<T[K]>>;

export const isDefined = <V extends unknown>(v: V | undefined): v is V => !!v;
export const isNotNullable = <V extends unknown>(
  v: V | undefined | null
): v is V => !!v;
